<template>
  <div>
    <v-skeleton-loader
        v-if="loading"
        class="loader"
        height="16"
        type="text"
        width="200"
    >
    </v-skeleton-loader>
    <span 
       v-else
       class="balance"
       :class="{'green--text': data.balance > 0, 'red--text': data.balance < 0}"
    >
      баланс c
      <span v-if="data.owner.balanceType === types.personal">организатором: </span>
      <span v-if="data.owner.balanceType === types.group">группой: </span>
      <b>{{data.balance | number}} {{ccy}}</b>
    </span>
  </div>
</template>

<script>
import {types} from '@/constants'

export default {
  name: 'BalancePreview',
  data () {
    return {
      types: types.balance
    }
  },
  props: {
    ccy: {
      type: String
    },
    data: {
      type: Object
    },
    loading: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="scss">
.balance {
  font-size: 12px;
  text-decoration: underline;
}
.loader {
  .v-skeleton-loader__text {
    margin: 0!important;
  }
}
</style>